import { getNotificationList } from '@/api/cs';
import AlertBottomSheet from '@/components/sideNavigation/Cs/common/AlertBottomSheet';
import CsAlertItem from '@/components/sideNavigation/Cs/alert/CsAlertItem';
import { useAppDispatch } from '@/hooks/useReduxHooks';
import { updateCs } from '@/store/modules/cs';
import { Icon } from '@successmode-ktp/kui';
import { useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import styled from 'styled-components';
import { Notification } from '@/types/cs.type';

function CsAlert() {
  const queryClient = useQueryClient();
  const dispatch = useAppDispatch();

  const [openedBottomSheet, setOpenedBottomSheet] = useState<number | null>(
    null,
  );

  const [alertList, setAlertList] = useState<Notification[]>([]);
  const { data } = useQuery(['AlertList'], getNotificationList, {
    onSuccess: (data) => {
      const newAlertList = data.events.filter(
        (item) =>
          item.message.notificationType !== 'FOR_ADMIN' &&
          item.message.notificationType !== 'MODIFY',
      );
      setAlertList(newAlertList);
    },
  });

  const onCloseAlert = () => {
    dispatch(
      updateCs({
        isOpenAlert: false,
      }),
    );
  };

  return (
    <AlertModal>
      <Header>
        <SubTitle>
          <PrevButton onClick={onCloseAlert}>
            <Icon.ChevronLeft fillColor='#5F6165' />
          </PrevButton>
          <AlertLabel>알림</AlertLabel>
        </SubTitle>
      </Header>
      {alertList.length > 0 ? (
        <AlertList>
          {alertList.map((notification) => (
            <CsAlertItem
              notification={notification}
              onOpenBottomSheet={setOpenedBottomSheet}
            />
          ))}
        </AlertList>
      ) : (
        <NoResult>알림이 없습니다</NoResult>
      )}
      <AlertBottomSheet
        openedBottomSheet={openedBottomSheet}
        onClose={() => {
          queryClient.invalidateQueries('AlertList');
          queryClient.invalidateQueries('messageAlertList');
          setOpenedBottomSheet(null);
        }}
      />
    </AlertModal>
  );
}

const AlertModal = styled.aside`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  width: 100%;
  height: 100%;
  z-index: 650;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 30px 20px 14px 20px;
  height: 68px;
`;

const SubTitle = styled.strong`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
`;

const AlertLabel = styled.span`
  color: #3a3b3e;
`;

const PrevButton = styled.button`
  width: 24px;
  height: 24px;
  padding: 0;
  margin-right: 10px;
`;

const AlertList = styled.div`
  width: 100%;
  height: calc(100% - 68px - 12px); // height, margin-bottom
  padding: 0 20px;
  overflow-y: auto;
`;

const NoResult = styled.p`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 217px;
  color: #5f6165;
  font-size: 14px;
  font-weight: 500;
  line-height: 150%;
`;

export default CsAlert;
